/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tags_Reference_LabelInputs */

const he_notifications_tags_reference_label = /** @type {(inputs: Notifications_Tags_Reference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תגיות נבחרות`)
};

const en_notifications_tags_reference_label = /** @type {(inputs: Notifications_Tags_Reference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected Tags`)
};

/**
* | output |
* | --- |
* | "Selected Tags" |
*
* @param {Notifications_Tags_Reference_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_tags_reference_label = /** @type {((inputs?: Notifications_Tags_Reference_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tags_Reference_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_tags_reference_label(inputs)
	return en_notifications_tags_reference_label(inputs)
});